import React, {
  useState,
  useRef,
  useEffect,
  Children,
  isValidElement,
} from "react";

interface TabProps {
  title: string;
  children: React.ReactNode;
}

export const Tab = ({ children }: TabProps) => {
  return <>{children}</>;
};

interface TabsProps {
  children: React.ReactNode;
  defaultActiveTab?: number;
}

export const Tabs = ({ children, defaultActiveTab = 0 }: TabsProps) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTab);
  const tabRefs = useRef<(HTMLButtonElement | null)[]>([]);
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });

  const tabs = Children.toArray(children).filter(
    (child) => isValidElement(child) && child.type === Tab,
  );

  useEffect(() => {
    const el = tabRefs.current[activeTab];
    if (el) {
      setIndicatorStyle({ left: el.offsetLeft, width: el.offsetWidth });
    }
  }, [activeTab]);

  return (
    <div className="flex flex-col">
      <div className="relative bg-[#F2F5FA] border-b border-[#B0B9D1]">
        <div className="flex space-x-8 px-4 pl-0">
          {tabs.map((tab, index) => {
            if (isValidElement<TabProps>(tab)) {
              return (
                <button
                  key={index}
                  ref={(el) => {
                    tabRefs.current[index] = el;
                  }}
                  onClick={() => setActiveTab(index)}
                  className={`font-jakarata pb-3 px-2 text-sm font-semibold tracking-wide transition-colors duration-300 uppercase ${
                    activeTab === index
                      ? "text-blue-medium"
                      : "text-grey-blue-300"
                  }`}
                >
                  {tab.props.title}
                </button>
              );
            }
            return null;
          })}
        </div>

        <div
          className="absolute bottom-[-3px] h-[4px] bg-blue-medium transition-all duration-300"
          style={{
            left: indicatorStyle.left,
            width: indicatorStyle.width,
          }}
        />
      </div>

      <div className="">{tabs[activeTab]}</div>
    </div>
  );
};
